// @ts-nocheck
// LIBRARY
import React from 'react';
import { Col, Switch, Typography, Form, Input, Select, Button, Row as AntRow, Checkbox, Modal } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { UserAccessContext } from 'context/userAccess';
import { RegexInput, formatMobileNumber, regExCondition } from 'shared_components/pattern_input';
import HttpCodeMessage from 'shared_components/message_http_status';
import { showMessage } from 'services/settings/message';
import { createUserAccountAPI, getUserAccountsAPI, updateUserAccountAPI, unblockUserAccountAPI } from 'services/settings/userAccount';
import { getUserTypes } from 'services/settings/userType';
import openpgpService from 'services/encryption/openpgpService';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global'
import {
	drawerAdd,
	labels as gLabels,
	buttonLabels,
	fieldLabels,
	fieldRules,
	errorMessage,
	messagePrompts
} from '../settings';

// CSS
import './useraccountform.css';

const { Text } = Typography;
const { Option } = Select;

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 8 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 16 },
	},
};

class UserAccountForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			userTypeList: [],
			isBlocked: props.patientInfo.isBlocked || 0,
			formTouched: false,
		};

		this.formRef = React.createRef();
	}

	async componentDidMount() {
		const response = await getUserTypes();
		const getUserRef = await getUserAccountsAPI();
		console.log('drawer button', this.props.drawerButton)
		const disablePass = this.props.drawerButton === 'UPDATE' ? true : false

		const filteredUserTypes = (response && response.data && response.data.filter(userType => 
			userType.active === 1 || userType.userTypeID === this.props.patientInfo.userTypeID
		)) || [];
		const sortedUserTypes = filteredUserTypes.sort((a, b) => a.userType.localeCompare(b.userType));

		this.setState({
			userTypeList: sortedUserTypes,
			getUserRef: getUserRef.data,
			resetPassword: disablePass,
			isBlocked: this.props.patientInfo.isBlocked || 0,
		});

	}

	componentWillUnmount() {

		this.formRef.current.resetFields();
	}

	handleSubmit = async (values) => {
		console.log('values', values)
		const { getUserRef } = this.state;
		const { drawerButton } = this.props;
		const userData = sessionStorage.LOGGEDIN_USER_DATA ? JSON.parse(sessionStorage.LOGGEDIN_USER_DATA) : null;
		const middleName = values.middleName === undefined ? '' : values.middleName.toUpperCase();
		let resetPassValue = false;
		let submitForm = true;

		// Username check removed - backend will handle duplicate username validation

		// check reset password
		const passValue = values.password === undefined ? "" : values.password;
		if (!this.state.resetPassword && passValue === "") {
			resetPassValue = true;
		}

		if (resetPassValue) {
			submitForm = false;
		}

		// Encrypt password if provided
		let encryptedPassword = '';
		if (values.password) {
			try {
				encryptedPassword = await openpgpService.encrypt(values.password);
				console.log('Password encrypted successfully');
			} catch (error) {
				console.error('Error encrypting password:', error);
				showMessage('M0004');
				return;
			}
		}

		const vData = {
			userName: values.userName.toUpperCase(),
			userTypeID: values.userTypeID,
			givenName: values.givenName.toUpperCase(),
			lastName: values.lastName.toUpperCase(),
			middleName: middleName,
			password: encryptedPassword,
			registryNumber: values.registration_no,
			registryValidityDate: values.registration_validity,
			active: (values.active === true) ? 1 : 0,
			contactNumber: values.contactNumber,
			emailAdd: values.emailAdd,
		};

		if (submitForm) {
			if (drawerButton === drawerAdd) {
				const createdUserResponse = await createUserAccountAPI(vData);

				if (createdUserResponse.status === 201) {
					showMessage('M0002', {
						onClose: () => {
							this.props.onClose();
							this.props.onSuccess();
						}
					});
				}
			} else {
				vData.userID = values.userID;
				const updateUserResponse = await updateUserAccountAPI(vData).catch(() => { });

				if (updateUserResponse.status === 200) {

					if (userData && userData.userID === vData.userID) {
						userData.givenName = vData.givenName;
						userData.middleName = vData.middleName;
						userData.lastName = vData.lastName;
						userData.userName = vData.userName;
						sessionStorage.setItem(LOGGEDIN_USER_DATA, JSON.stringify(userData));
					}

					showMessage('M0003', {
						onClose: () => {
							this.props.onClose();
							this.props.onSuccess();
						}
					});
				}
			}
		} else {
			let errMessage = ''
			// if(userNameData){
			// 	errMessage = 'Username already exists.'
			// }

			if (resetPassValue) {
				errMessage = 'Please Enter Password.'
			}

			showMessage('M0005');
		}
	}

	// @ts-ignore
	compareToFirstPassword = (rule, value, callback) => {
		const { getFieldValue } = this.formRef.current;

		if (value && value !== getFieldValue('password')) {
			callback(errorMessage.password.doesNotMatch);
		} else {
			callback();
		}
	};

	nameOnChange = (e) => {
		const formatValue = regExCondition(e.target.value, 'conditionA')

		if (e.target.id === 'givenName') {
			this.formRef.current.setFieldsValue({ givenName: formatValue });
		}

		if (e.target.id === 'middleName') {
			this.formRef.current.setFieldsValue({ middleName: formatValue });
		}

		if (e.target.id === 'lastName') {
			this.formRef.current.setFieldsValue({ lastName: formatValue });
		}

		if (e.target.id === 'userName') {
			this.formRef.current.setFieldsValue({ userName: formatValue });
		}
	}

	contactNumberOnChange = (e) => {
		const contNum = e.target.value === '' ? 0 : e.target.value;

		const formatedValue = formatMobileNumber(contNum);
		this.formRef.current.setFieldsValue({ contactNumber: formatedValue });
	}

	handleResetPassOnChange = (e) => {
		const resetValue = e.target.checked === true ? false : true

		this.setState({ resetPassword: resetValue });
		if (!resetValue) {
			this.formRef.current.setFieldsValue({ password: undefined, repeatPassword: undefined })
		}
	}


	handleUnblockUser = async () => {
		const { patientInfo } = this.props;

		if (!patientInfo.userID) {
			showMessage('M0004');
			return;
		}

		const unblockResponse = await unblockUserAccountAPI(patientInfo.userID);

		if (unblockResponse.status === 200) {
			// Update state to hide the button immediately
			this.setState({ isBlocked: 0 });

			// Update the patientInfo object as well
			if (patientInfo.isBlocked !== undefined) {
				patientInfo.isBlocked = 0;
			}

			showMessage('M0003', {
				onClose: () => {
					this.props.onSuccess();
				}
			});
		}
	}

	handleFieldsChange = () => {
		if (!this.state.formTouched) {
			this.setState({ formTouched: true });
		}
	}

	handleCancel = () => {
		const { formTouched } = this.state;

		if (formTouched) {
			Modal.confirm({
				title: 'Unsaved Changes',
				content: 'You have unsaved changes. Are you sure you want to cancel?',
				okText: 'Yes, Cancel',
				cancelText: 'No, Stay',
				onOk: () => {
					this.props.onClose();
				}
			});
		} else {
			this.props.onClose();
		}
	}

	render() {
		const { patientInfo, drawerButton } = this.props;
		// const { getFieldDecorator, getFieldsValue } = form;
		const { userTypeList, resetPassword, isBlocked } = this.state;

		const UserTypeOptions = userTypeList.map(userType => (
			<Option value={userType.userTypeID} key={userType.userTypeID}>
				{userType.userType.toUpperCase()}
			</Option>
		));

		const isActive = (patientInfo.active === 1);

		return (
			<div>
				<Form
					ref={this.formRef}
					{...formItemLayout}
					onFinish={this.handleSubmit}
					onFieldsChange={this.handleFieldsChange}
					className="settings-user-maintence-form"
					layout="horizontal"
				>
					<section style={{ 'overflow': 'hidden' }}>
						<AntRow>
							{
								drawerButton === drawerAdd ?
									(
										<Col xs={24} sm={24} style={{ textAlign: "right" }}>
											<Form.Item
												name="active"
												label="ENABLE LOGIN"
												valuePropName="checked"
												labelCol={{ span: 22 }}
												wrapperCol={{ span: 1 }}
												initialValue={true}
											>
												<Switch defaultChecked disabled={true} />
											</Form.Item>
										</Col>
									)
									:
									<Col xs={24} sm={24} style={{ textAlign: "right" }}>
										<Form.Item
											name="active"
											label="ENABLE LOGIN"
											valuePropName="checked"
											labelCol={{ span: 22 }}
											wrapperCol={{ span: 1 }}
											initialValue={isActive}
										>
											<Switch />
										</Form.Item>
									</Col>
							}

						</AntRow>
					</section>
					<section
					// style={{ marginBottom: 50 }}
					>
						<AntRow>
							<Col span={12}>
								{/* PERSONAL INFORMATION */}
								<div className="form-section">
									<div className="form-title">
										<Text strong>{gLabels.personalInfoLabel}</Text>
									</div>
									<Form.Item
										name="userID"
										label={fieldLabels.userID}
										initialValue={patientInfo.userID}
									>
										<Input disabled />
									</Form.Item>
									<Form.Item
										name="givenName"
										label={fieldLabels.firstName}
										initialValue={patientInfo.givenName}
										rules={fieldRules.firstname}
									>
										<Input
											onChange={this.nameOnChange}
											maxLength={50}
										/>
									</Form.Item>
									<Form.Item
										name="middleName"
										label={fieldLabels.middleName}
										initialValue={patientInfo.middleName}
										rules={fieldRules.middlename}
									>
										{/* <RegexInput
											regex={/[A-Za-z0-9. -]/} 
											maxLength={15} 
										/> */}
										<Input
											onChange={this.nameOnChange}
											maxLength={50}
										/>
									</Form.Item>
									<Form.Item
										name="lastName"
										label={fieldLabels.lastName}
										initialValue={patientInfo.lastName}
										rules={fieldRules.lastname}
									>
										{/* <RegexInput
											regex={/[A-Za-z0-9. -]/} 
											maxLength={50} 
										/> */}
										<Input
											onChange={this.nameOnChange}
											maxLength={50}
										/>
									</Form.Item>
									<Form.Item
										name="contactNumber"
										label={fieldLabels.contactNumber}
										initialValue={patientInfo.contactNumber}
										rules={fieldRules.contactNumber}
									>
										<Input
											addonBefore="+ 63"
											maxLength={12}
											onChange={this.contactNumberOnChange}
											placeholder='999-999-9999'
										/>
									</Form.Item>
									<Form.Item
										name="emailAdd"
										label={fieldLabels.emailAddress}
										initialValue={patientInfo.email || patientInfo.emailAdd}
										rules={fieldRules.emailAddress}
									>
										<Input maxLength={100} />
									</Form.Item>
								</div>
							</Col>
							<Col span={12}>
								{/* ACCOUNT INFORMATION */}
								<div className="form-section" style={{ marginLeft: '10px' }}>
									<div className="form-title">
										<Text strong>{gLabels.accountInfoLabel}</Text>
									</div>
									<Form.Item
										name="userName"
										label={fieldLabels.username}
										initialValue={patientInfo.userName}
										rules={fieldRules.username}
									>
										{/* <AlphaNumInput maxLength={10} /> */}
										<Input
											onChange={this.nameOnChange}
											maxLength={10}
										/>
									</Form.Item>
									{
										drawerButton === 'UPDATE' ?
											(<Form.Item
												name="resetPassword"
												label="RESET PASSWORD"
											>
												<Checkbox onChange={this.handleResetPassOnChange} ></Checkbox>
											</Form.Item>) : <></>
									}
									<Form.Item
										name="password"
										label={fieldLabels.password}
										hasFeedback
										rules={[
											...fieldRules.password,
											{
												required: drawerAdd === drawerButton || !resetPassword,
												message: errorMessage.requiredField
											},
										]}
										dependencies={['repeat_password']}
									>
										<Input.Password
											className="password_input"
											maxLength={12}
											disabled={resetPassword}
										/>
									</Form.Item>
									<Form.Item wrapperCol={{ span: 24 }} shouldUpdate>
										{({ getFieldsValue }) => {
											return (
												<Form.Item
													name="repeat_password"
													label={fieldLabels.repeatPassword}
													labelCol={{ span: 8 }}
													rules={[
														...fieldRules.repeat_password,
														{
															required: drawerAdd === drawerButton || !resetPassword || getFieldsValue().password,
															message: errorMessage.requiredField
														},
														{ validator: this.compareToFirstPassword }
													]}
													dependencies={['password']}
													hasFeedback
												>
													<Input.Password
														className="password_input"
														maxLength={12}
														disabled={resetPassword}
													/>
												</Form.Item>
											);
										}}
									</Form.Item>
								</div>
								{/* other information */}
								<div className="form-section" style={{ marginLeft: '10px' }} >
									<div className="form-title">
										<Text strong>{gLabels.otherInfoLabel}</Text>
									</div>
									<Form.Item
										name="registration_no"
										label={fieldLabels.registrationNo}
										initialValue={patientInfo.registryNumber}
									>
										<RegexInput
											regex={/[A-Za-z0-9 -]/}
											maxLength={50}
											disabled={false}
										/>
									</Form.Item>
									<Form.Item
										name="registration_validity"
										label={fieldLabels.registrationValidity}
										initialValue={patientInfo.registryValidityDate}
									>
										<RegexInput
											regex={/[A-Za-z0-9 -]/}
											maxLength={50}
											disabled={false}
										/>
									</Form.Item>
									<Form.Item
										name="userTypeID"
										label={fieldLabels.userRights}
										initialValue={patientInfo.userTypeID}
										rules={[{ required: true, message: errorMessage.requiredField }]}
									>
										<Select disabled={false}>
											{UserTypeOptions}
										</Select>
									</Form.Item>
								</div>
							</Col>
						</AntRow>
					</section>
					<section className="drawerFooter">
						<React.Fragment>
							<Button shape="round" style={{ margin: 5, width: 120 }} onClick={this.handleCancel}>
								{buttonLabels.cancel}
							</Button>
							{isBlocked === 1 && drawerButton === 'UPDATE' && (
								<Button
									type="danger"
									shape="round"
									style={{ margin: 5, width: 120 }}
									onClick={this.handleUnblockUser}
								>
									UNBLOCK
								</Button>
							)}
							<UserAccessContext.Consumer>
								{value => value.userAccess.settings.create && (
									<Button
										type="primary"
										shape="round"
										style={{ margin: 5, width: 120 }}
										htmlType="submit"
									>
										{drawerButton}
									</Button>
								)}
							</UserAccessContext.Consumer>
						</React.Fragment>
					</section>
				</Form>
			</div>
		);
	}
}

UserAccountForm.propTypes = {
	patientInfo: PropTypes.array.isRequired,
	drawerButton: PropTypes.string.isRequired,
	onClose: PropTypes.func,
	onSuccess: PropTypes.func
}

UserAccountForm.defaultProps = {
	onClose() { return null }
};


export default withRouter(UserAccountForm);